class LegalPopup extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onPopupClick.bind(this));
    const openText =
      document.querySelector('.nwb-legal-checkbox p strong') || document.querySelector('.pnb-legal-checkbox p strong');
    openText?.addEventListener('click', this.onPopupClick.bind(this));
  }

  onPopupClick(event) {
    event.preventDefault();
    if (event.target.closest('.nwb-legal-checkbox p strong') || event.target.closest('.pnb-legal-checkbox p strong')) {
      this.open();
    } else if (!event.target.closest('.legal-content') || event.target.closest('.close-popup')) {
      this.close();
    }
  }

  open() {
    this.classList.add('open');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('open');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('legal-popup', LegalPopup);
